class AnnouncementBar extends HTMLElement {
  constructor() {
    super()

    this.swiperEl = this.querySelector('swiper-container')
  }

  connectedCallback() {
    this.swiperEl.addEventListener('swiperslidechangetransitionend', () => {
      this.setSlidesA11y(this.swiperEl)
    });
  }

  setSlidesA11y(swiperEl) {
    swiperEl.querySelectorAll('swiper-slide').forEach(slide => {
      if (slide.classList.contains('swiper-slide-active')) {
        slide.removeAttribute('inert')
      } else {
        slide.setAttribute('inert', '')
      }
    })
  }
}
window.customElements.define('announcement-bar', AnnouncementBar)
